import { render, staticRenderFns } from "./plantao.vue?vue&type=template&id=5fb4d51e&scoped=true"
import script from "./plantao.vue?vue&type=script&lang=ts"
export * from "./plantao.vue?vue&type=script&lang=ts"
import style0 from "./plantao.vue?vue&type=style&index=0&id=5fb4d51e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb4d51e",
  null
  
)

export default component.exports